export default "__VITE_ASSET__BbQqeDSe__"